import DOMPurify from 'dompurify'
import { cn } from 'components/UI/cn'
import { linkifyPlainTextPreview } from './linkifyPlainTextPreview'

/**
 * Renders an already-rendered (`renderEmail`) body + signature identically on
 * the Build and Review pages so the signature preview can't drift between them
 * (FIR-7459). Owns both display branches:
 *  - plaintext: a `<pre>` that linkifies bare URLs and applies display-only
 *    dash/hyphen line-break fixes (see linkifyPlainTextPreview),
 *  - html: sanitized HTML with link/list/spacing styling.
 *
 * `renderedBody` is the output of `renderEmail` (variables filled, signature
 * appended) -- this component only presents it, it does not append signatures.
 */
export function EmailPreviewBody({
  renderedBody,
  isPlainText,
}: {
  renderedBody: string
  isPlainText: boolean
}) {
  if (isPlainText) {
    return (
      <pre className="whitespace-pre-wrap font-sans text-sm text-fg [overflow-wrap:normal] [word-break:normal] [hyphens:none]">
        {linkifyPlainTextPreview(renderedBody)}
      </pre>
    )
  }
  return (
    <div
      className={cn(
        'max-w-full break-words font-sans text-sm text-fg [overflow-wrap:break-word]',
        '[&_a]:text-brand [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5'
      )}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderedBody) }}
    />
  )
}
